







































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import {
  required,
  minLength,
  maxLength,
  between,
} from 'vuelidate/lib/validators'
import controller from '@/app/ui/controllers/DropBoxController'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import DropBoxTextInput from '../components/DropBoxTextInput/index.vue'
import DropBoxDropdown from '../components/DropBoxDropdown/index.vue'
import ConfirmationIcon from '@/app/ui/assets/icon_confirmation.vue'

interface VisibilityOption {
  label: string
  value: string
}

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    Modal,
    LoadingOverlay,
    DropBoxTextInput,
    DropBoxDropdown,
    ConfirmationIcon,
  },
})
export default class CreateDropBoxPage extends Vue {
  controller = controller
  confirmationModal = false
  discardModal = false
  isValidate = false

  visibilityOptions: VisibilityOption[] = [
    { label: 'Shown', value: 'SHOWN' },
    { label: 'Hidden', value: 'HIDDEN' },
  ]

  form = {
    name: '',
    serialNumber: '',
    lat: null as number | null,
    long: null as number | null,
    address: '',
    phoneNumber: '',
    picAgentCode: '',
    visibility: null as VisibilityOption | null,
  }

  get latDisplayValue(): string {
    return this.form.lat !== null ? this.form.lat.toString() : ''
  }

  get longDisplayValue(): string {
    return this.form.long !== null ? this.form.long.toString() : ''
  }

  @Validations()
  validations(): Record<string, unknown> {
    return {
      form: {
        name: { required, minLength: minLength(7), maxLength: maxLength(100) },
        serialNumber: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(500),
        },
        lat: { required, between: between(-90, 90) },
        long: { required, between: between(-180, 180) },
        address: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(1000),
        },
        phoneNumber: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(20),
        },
        picAgentCode: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(100),
        },
        visibility: { required },
      },
    }
  }

  @Watch('controller.createSuccess')
  onCreateSuccess(val: boolean): void {
    if (val) {
      this.confirmationModal = false
      this.$router.push({ name: 'DropBoxListPage' })
    }
  }

  private getErrorMessage(field: string): string | undefined {
    if (!this.isValidate) return undefined
    const validation = this.$v.form[field]
    if (!validation || !validation.$invalid) return undefined

    const messages: Record<string, string> = {
      name: 'Name must be between 7-100 characters',
      serialNumber: 'Serial number must be between 10-500 characters',
      lat: 'Latitude must be between -90 and 90',
      long: 'Longitude must be between -180 and 180',
      address: 'Address must be between 10-1000 characters',
      phoneNumber: 'Phone number must be between 7-20 characters',
      picAgentCode: 'Agent code must be between 5-100 characters',
      visibility: 'Visibility is required',
    }
    return messages[field]
  }

  private onShowConfirmation(): void {
    this.isValidate = true
    if (!this.$v.form.$invalid) {
      this.confirmationModal = true
    }
  }

  private formatPhoneWithPrefix(phone: string): string {
    if (!phone || !phone.trim()) return phone
    const trimmed = phone.trim()
    if (trimmed.startsWith('+62')) return trimmed
    if (trimmed.startsWith('62')) return '+' + trimmed
    if (trimmed.startsWith('0')) return '+62' + trimmed.slice(1)
    return '+62' + trimmed
  }

  private onCreateDropBox(): void {
    this.confirmationModal = false
    controller.createDropBox({
      name: this.form.name,
      serialNumber: this.form.serialNumber,
      lat: this.form.lat as number,
      long: this.form.long as number,
      address: this.form.address,
      phoneNumber: this.formatPhoneWithPrefix(this.form.phoneNumber),
      picAgentCode: this.form.picAgentCode,
      visibility: (this.form.visibility as VisibilityOption).value,
    })
  }

  private onDiscard(): void {
    const hasFormData = Object.values(this.form).some(
      val => val !== '' && val !== null
    )
    if (hasFormData) {
      this.discardModal = true
    } else {
      this.$router.push({ name: 'DropBoxListPage' })
    }
  }

  private onConfirmDiscard(): void {
    this.discardModal = false
    this.$router.push({ name: 'DropBoxListPage' })
  }

  private normalizeCoordinateInput(value: string): string {
    // Replace comma with dot
    let normalized = value.replace(/,/g, '.')

    // Remove all dots except the first one
    const firstDotIndex = normalized.indexOf('.')
    if (firstDotIndex !== -1) {
      normalized =
        normalized.slice(0, firstDotIndex + 1) +
        normalized.slice(firstDotIndex + 1).replace(/\./g, '')
    }

    // Remove any non-numeric characters except dots and minus sign at the start
    normalized = normalized.replace(/[^0-9.-]/g, '')

    // Ensure minus sign only appears at the start
    const minusCount = (normalized.match(/-/g) || []).length
    if (minusCount > 0) {
      normalized = '-' + normalized.replace(/-/g, '')
    }

    return normalized
  }

  private onLatInput(value: string): void {
    const normalized = this.normalizeCoordinateInput(value)

    if (normalized === '' || normalized === '-') {
      this.form.lat = null
      return
    }

    const numValue = parseFloat(normalized)
    if (!isNaN(numValue)) {
      this.form.lat = numValue
    }
  }

  private onLongInput(value: string): void {
    const normalized = this.normalizeCoordinateInput(value)

    if (normalized === '' || normalized === '-') {
      this.form.long = null
      return
    }

    const numValue = parseFloat(normalized)
    if (!isNaN(numValue)) {
      this.form.long = numValue
    }
  }
}
